// extracted by mini-css-extract-plugin
export var phone = "_2j-0";
export var phoneDragging = "_2j-1";